import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  user: null,
  token: null,
  refreshToken: null,
  expiresAt: null,
  userEmail: null,
  isRegister: false,
  uniqueKey: null,
  isShow: false,
};

export const userSlice = createSlice({
  initialState,
  name: "userSlice",
  reducers: {
    logout: () => initialState,
    setUser: (state, action) => {
      state.user = {
    ...state.user,    
    ...action.payload 
  };
    },
    setIsShow: (state, action) => {
      state.isShow = action.payload;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setIsRegister: (state, action) => {
      state.isRegister = action.payload;
    },
    setUniqueKey: (state, action) => {
      state.uniqueKey = action.payload;
    },
    setToken: (state, action) => {
      const { token, refreshToken, expiresAt } = action.payload;
      return {
        ...state,
        token,
        refreshToken,
        expiresAt,
      };
    },
  },
});

export const reducer = persistReducer(
  {
    key: "PH:Auth",
    storage,
    whitelist: ["user", "token", "refreshToken", "expiresAt"],
  },
  userSlice.reducer
);

export default reducer;
export const {
  logout,
  setUser,
  setToken,
  setUserEmail,
  setIsRegister,
  setUniqueKey,
  setIsShow,
} = userSlice.actions;
